import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-lobby-item-card',
  templateUrl: './lobby-item-card.component.html',
  styleUrls: ['./lobby-item-card.component.scss']
})
export class LobbyItemCardComponent implements OnInit {

  @Input() item!: any;

  constructor() { }

  ngOnInit(): void {
  }

}
